import { BackgroundColorName, mapBackgroundColor } from "@/helpers/mapBackgroundColor";
import { FC } from "react";

type BackgroundColorWrapperProps = {
  children: React.ReactNode;
  backgroundColorName: BackgroundColorName;
}

const BackgroundColorWrapper: FC<BackgroundColorWrapperProps> = ({ children, backgroundColorName }) => {
  return <div className={mapBackgroundColor(backgroundColorName)}>{children}</div>;
};

export default BackgroundColorWrapper;
